export default function PublicProfileUserCardSkeleton() {
  return (
    <div
      className="flex min-w-[350px] max-w-[350px] animate-pulse flex-col gap-4 rounded-[40px] border-[0.5px] bg-white lg:min-w-[500px] lg:max-w-[500px]"
      style={{ boxShadow: '0px 2px 12px 1px rgba(27, 48, 41, 0.10)', borderColor: 'rgba(170, 171, 173, 0.40)' }}
    >
      {/* Cover photo skeleton */}
      <div className="h-[160px] w-full rounded-t-[40px] bg-gray-200" />

      {/* Main card with negative margin to hover over cover photo */}
      <div className="mb-[-50px] flex translate-y-[-50px] flex-col gap-2 rounded-[40px] bg-white">
        <div className="mb-[-20px] flex translate-y-[-50px] flex-col gap-2">
          <div className="flex flex-col items-center gap-2 px-5 lg:px-8">
            {/* Profile photo skeleton */}
            <div
              className="mb-1 size-[100px] rounded-full border-[5px] border-white bg-gray-200 object-cover lg:mb-3"
              style={{
                boxShadow: '0px 2px 12px 1px rgba(27, 48, 41, 0.10)',
              }}
            />
            {/* Name and verification skeleton */}
            <div className="flex flex-col items-center">
              <div className="flex items-center gap-2">
                <div className="h-6 w-32 rounded bg-gray-200 lg:h-7 lg:w-36" />
                <div className="size-6 rounded-full bg-gray-200 lg:size-7" />
              </div>
              <div className="mt-2 h-4 w-24 rounded bg-gray-200 lg:h-5 lg:w-28" />
            </div>
            {/* Bio skeleton */}
            <div className="relative w-full text-sm lg:text-base">
              <div className="mb-2 h-4 w-full rounded bg-gray-200" />
              <div className="h-4 w-2/3 rounded bg-gray-200" />
            </div>
            {/* Info row skeleton */}
            <div className="my-2 flex w-full flex-row items-center justify-center gap-3">
              <div className="h-4 w-24 rounded bg-gray-200" />
              <div className="size-4 rounded-full bg-gray-200" />
              <div className="h-4 w-12 rounded bg-gray-200" />
              <div className="size-4 rounded-full bg-gray-200" />
              <div className="h-4 w-20 rounded bg-gray-200" />
            </div>
            {/* Buttons skeleton */}
            <div className="mt-2 flex flex-col items-center gap-3 lg:flex-row">
              <div className="h-10 w-32 rounded-full bg-gray-200" />
              <div className="h-10 w-40 rounded-full bg-gray-200" />
            </div>
            {/* Divider skeleton */}
            <div className="my-4 h-px w-full bg-gray-200 lg:my-7" />
          </div>
          {/* General info sections skeleton */}
          <div className="flex flex-col gap-4 px-5 lg:gap-6 lg:px-8">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="flex flex-row items-start gap-3">
                <div className="size-7 rounded bg-gray-200 lg:size-8" />
                <div className="flex flex-col items-start justify-start gap-2">
                  <div className="h-5 w-32 rounded bg-gray-200" />
                  <div className="h-4 w-48 rounded bg-gray-200" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
